<div class="giving-space-block" [class.reverse]="data().reverse">
  <div class="content">
    @if (data().heading) {
      <h2 class="heading">{{ data().heading | translateLang }}</h2>
    }
    @if (data().description) {
      <div class="description" [innerHTML]="data().description | translateLang"></div>
    }
    @if (data().buttonLabel) {
      <app-button
        [label]="data().buttonLabel | translateLang"
        variant="yellow"
        (clicked)="onButtonClick()">
      </app-button>
    }
  </div>
  <div class="image-container">
    @if (data().imageSrc) {
      <img [src]="data().imageSrc" [alt]="data().imageAlt || 'GivingSpace'" class="image" />
    }
  </div>
</div>
